import { INITIALIZE_PAYSTACK_TRANSACTION, CANCEL_CARD_SUBSCRIPTION } from "./actionTypes";

export const initializePaystackTransaction = (payload) => ({
    type: INITIALIZE_PAYSTACK_TRANSACTION,
    payload
});

export const cancelCardSubscription = () => ({
    type: CANCEL_CARD_SUBSCRIPTION
})